import Constants from '../assests/Constants/constants';

const INCOME_VAT_LABEL = 'VatTransactions';
const EXPENSE_VAT_LABELS = new Set(['VatExpenses', 'VatEquipment']);

function isJournalDocType(docType) {
    const type = String(docType || '');
    return type === 'JournalEntries' || type === 'JournalEntry';
}

function isExpenseDocType(docType) {
    const type = String(docType || '');
    return type === 'Expenses' || type === 'Expense';
}

function isIncomeDocType(docType) {
    const type = String(docType || '');
    return type === 'Incomes' || type === 'Income';
}

export function resolveSortCodeVatTypeLabel(sortCodeVatType) {
    if (sortCodeVatType == null || sortCodeVatType === '') return null;

    if (
        typeof sortCodeVatType === 'string' &&
        Constants.SortCodeVatTypeValue?.[sortCodeVatType] != null
    ) {
        return sortCodeVatType;
    }

    const numeric = Number(sortCodeVatType);
    if (!Number.isNaN(numeric) && Constants.SortCodeVatType?.[numeric] != null) {
        return Constants.SortCodeVatType[numeric];
    }

    return Constants.SortCodeVatType?.[sortCodeVatType] ?? null;
}

export function lookupSortCodeVatType(sortCodeId, sortCodeOptions, fallbackDocument) {
    const sortCode = Array.isArray(sortCodeOptions)
        ? sortCodeOptions.find((sc) => String(sc.sortCodeId) === String(sortCodeId))
        : null;

    return (
        sortCode?.sortCodeVatType ??
        sortCode?.SortCodeVatType ??
        fallbackDocument?.sortCodeVatType ??
        fallbackDocument?.SortCodeVatType ??
        null
    );
}

/**
 * Income sort codes are VatTransactions; expense sort codes are VatExpenses / VatEquipment.
 * Journal entries may mix both, so they never mismatch.
 *
 * @returns {{ isMismatch: boolean, messageKey: string|null }}
 */
export function getSortCodeDocTypeMismatch(docType, sortCodeVatType) {
    if (isJournalDocType(docType)) {
        return { isMismatch: false, messageKey: null };
    }

    const vatLabel = resolveSortCodeVatTypeLabel(sortCodeVatType);
    if (!vatLabel) {
        return { isMismatch: false, messageKey: null };
    }

    const isIncomeSortCode = vatLabel === INCOME_VAT_LABEL;
    const isExpenseSortCode = EXPENSE_VAT_LABELS.has(vatLabel);

    if (isExpenseDocType(docType) && isIncomeSortCode) {
        return { isMismatch: true, messageKey: 'IncomeSortCodeOnExpenseDocument' };
    }

    if (isIncomeDocType(docType) && isExpenseSortCode) {
        return { isMismatch: true, messageKey: 'ExpenseSortCodeOnIncomeDocument' };
    }

    return { isMismatch: false, messageKey: null };
}
